import { Divider, InputNumber } from "antd";
import Form from "antd/lib/form/Form";
import { Formik } from "formik";
import React, { useContext } from "react";
import FormItem from "antd/lib/form/FormItem";
import ReactQuill from "react-quill";
import "../styles/naocdailyproduction.css";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import "react-quill/dist/quill.snow.css";
import NaocDailyProductionStore from "../store/naocdailyproductionstore";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";

import formatNumber from "accounting-js/lib/formatNumber.js";
import { reactQuiltoolbarOptions } from "../../../Utility/modules/helpers";
import { MessageBar, MessageBarType } from "@fluentui/react";

export const NaocDailyProductionForm = observer(() => {
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  return (
    <Formik
      initialValues={toJS(naocDailyProductionStore.initFormaData)}
      enableReinitialize={true}
    >
      {({ values }) => (
        <Form
          layout="vertical"
          labelAlign="left"
          style={{ background: "#fff", padding: "10px" }}
        >
          <div className="ms-Grid" dir="ltr">
            <Divider>PRODUCTION AND EVACUATIONS</Divider>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm4">
                <SubPageHeaderTitle title="OIL PRODUCTION (bopd)" color="red" />
                <FormItem
                  label="Land Area Metered/Adjusted"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="landAreaOil"
                    value={values?.landAreaOil}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.landAreaOil =
                        value;
                    }}
                  />
                </FormItem>

                <FormItem
                  label="Swamp Area Metered/Adjusted"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="swampAreaOil"
                    value={values?.swampAreaOil}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.swampAreaOil =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="BENIBOYE Daily Metered"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="beniboyeOilDailyMetered"
                    value={values?.beniboyeOilDailyMetered}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.beniboyeOilDailyMetered =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Total Metered/Adjusted Prod"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="totalOilMeteredProd"
                    value={values?.totalOilMeteredProd}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.totalOilMeteredProd =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Total NAOC JV Oil Produced/Evacuated"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="totalOilProduced"
                    value={values?.totalOilProduced}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.totalOilProduced =
                        value;
                    }}
                  />
                </FormItem>
              </div>
              <div className="ms-Grid-col ms-sm4">
                <SubPageHeaderTitle
                  title="GAS PRODUCTION (mscf/d)"
                  color="green"
                />
                <FormItem
                  label="Land Area Gas Produced"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="landAreaGas"
                    value={values?.landAreaGas}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.landAreaGas =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Swamp Area Gas Produced"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="swampAreaGas"
                    value={values?.swampAreaGas}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.swampAreaGas =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Total Gas Produced"
                  labelAlign="left"
                  className="add-border"
                  style={{
                    backgroundColor: "#f2f2f2",
                    padding: "5px",
                    width: "215px",
                  }}
                >
                  <span style={{ color: "#1890ff", fontWeight: "bold" }}>
                    {formatNumber(naocDailyProductionStore.totalGasProduced, {
                      precision: 2,
                      thousand: ",",
                    })}
                  </span>
                </FormItem>
                <Divider
                  style={{ marginTop: "2px", color: "#48BB78" }}
                  orientation="left"
                  dashed
                ></Divider>
                <SubPageHeaderTitle
                  title="  GAS UTILIZATION (mscf/d)"
                  color="#22543D"
                />
                <FormItem
                  label="Total Gas Flared"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="totalGasFlared"
                    value={values?.totalGasFlared}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.totalGasFlared =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Total Gas Internally Utilized"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="totalGasInternallyUtilized"
                    value={values?.totalGasInternallyUtilized}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.totalGasInternallyUtilized =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Gas Utilized for NGL"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="gasInternallyUtilizedforNGL"
                    value={values?.gasInternallyUtilizedforNGL}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.gasInternallyUtilizedforNGL =
                        value;
                    }}
                  />
                </FormItem>
              </div>
              <div className="ms-Grid-col ms-sm4">
                <SubPageHeaderTitle
                  title=" GAS EVACUATION (mscf/d)"
                  color="#48BB78"
                />
                <FormItem
                  label="Daily FuelGas To EPCL."
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="dailyFuelGasToEPCL"
                    value={values?.dailyFuelGasToEPCL}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.dailyFuelGasToEPCL =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Daily Gas Delivery to RS IPP"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="dailyGasDeliveryToRSIPP"
                    value={values?.dailyGasDeliveryToRSIPP}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.dailyGasDeliveryToRSIPP =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Daily Gas Delivery to BONNY"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="dailyGasDeliveryToBonny"
                    value={values?.dailyGasDeliveryToBonny}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.dailyGasDeliveryToBonny =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Daily Gas Delivery to JV IPP"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="dailyGasJVIPP"
                    value={values?.dailyGasJVIPP}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.dailyGasJVIPP =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Daily Gas To EPCL FERT PLT"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="dailyGasEPCLFertPLT"
                    value={values?.dailyGasEPCLFertPLT}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.dailyGasEPCLFertPLT =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Total Gas Evacuated"
                  labelAlign="left"
                  className="add-border"
                  style={{
                    backgroundColor: "#f2f2f2",
                    padding: "5px",
                    width: "215px",
                  }}
                >
                  <span style={{ color: "#1890ff", fontWeight: "bold" }}>
                    {formatNumber(naocDailyProductionStore.totalGasEvacuated, {
                      precision: 2,
                      thousand: ",",
                    })}
                  </span>
                </FormItem>
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm4">
                <SubPageHeaderTitle
                  title="GAS INJECTION / LIFT (mscf/d)"
                  color="#68D391"
                />
                <FormItem
                  label="OB/OB G/Plant Gas Inj./Lift"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "50%" }}
                    name="obGpGasInj"
                    value={values?.obGpGasInj}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.obGpGasInj = value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Kwale G/Plant Gas Inj./Lift"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "50%" }}
                    name="kwaleGpGasInj"
                    value={values?.kwaleGpGasInj}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.kwaleGpGasInj =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Akri Gas To Oguta Plant"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "50%" }}
                    name="akriGasToOGutaPlant"
                    value={values?.akriGasToOGutaPlant}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.akriGasToOGutaPlant =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Gas Inj.Into Akri 2 at Oguta"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "50%" }}
                    name="akriGasInjToOGutaPlant"
                    value={values?.akriGasInjToOGutaPlant}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.akriGasInjToOGutaPlant =
                        value;
                    }}
                  />
                </FormItem>
              </div>
              <div className="ms-Grid-col ms-sm4">
                {" "}
                <SubPageHeaderTitle
                  title="GAS METERS (mscf/d)"
                  color="#2F855A"
                />
                <FormItem
                  label="Total Gas Rec. at OB/OB G/Plant"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="totalGasRecOBGp"
                    value={values?.totalGasRecOBGp}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.totalGasRecOBGp =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="Total Gas Rec. at Kwale G/Plant"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="totalGasRecKwaleGp"
                    value={values?.totalGasRecKwaleGp}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.totalGasRecKwaleGp =
                        value;
                    }}
                  />
                </FormItem>
                <fieldset
                  style={{
                    padding: "5px",
                  }}
                >
                  <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm12">
                        <b>PRODUCTION UPTIME</b>
                      </div>
                    </div>
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm6">
                        {" "}
                        <FormItem
                          label="MTD Uptime"
                          labelAlign="left"
                          className="add-border"
                        >
                          <InputNumber
                            min={0}
                            name="mtdUptime"
                            style={{ minWidth: "80%" }}
                            value={values?.mtdUptime}
                            onChange={(value) => {
                              naocDailyProductionStore.initFormaData.mtdUptime =
                                value;
                            }}
                          />
                        </FormItem>
                      </div>
                      <div className="ms-Grid-col ms-sm6">
                        {" "}
                        <FormItem
                          label="YTD Uptime"
                          labelAlign="left"
                          className="add-border"
                        >
                          <InputNumber
                            min={0}
                            name="ytdUptime"
                            style={{ minWidth: "80%" }}
                            value={values?.ytdUptime}
                            onChange={(value) => {
                              naocDailyProductionStore.initFormaData.ytdUptime =
                                value;
                            }}
                          />
                        </FormItem>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="ms-Grid-col ms-sm4">
                {" "}
                <SubPageHeaderTitle title="NGL (bopd)" color="#D69E2E" />
                <FormItem
                  label="NGL Produced"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="nglProduced"
                    value={values?.nglProduced}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.nglProduced =
                        value;
                    }}
                  />
                </FormItem>
                <FormItem
                  label="NGL Delivered"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="nglDelivered"
                    value={values?.nglDelivered}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.nglDelivered =
                        value;
                    }}
                  />
                </FormItem>
              </div>
            </div>
            <Divider>PRODUCTION UNITIZATIONS</Divider>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm3">
                <FormItem
                  label=" SPDC Akri/Oguta Share"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="spdcAkriOguta"
                    value={values?.spdcAkriOguta}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.spdcAkriOguta =
                        value;
                    }}
                  />
                </FormItem>
              </div>
              <div className="ms-Grid-col ms-sm3">
                <FormItem
                  label=" SPDC Ogbain/Afuo Share"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="spdcOgbainAfuo"
                    value={values?.spdcOgbainAfuo}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.spdcOgbainAfuo =
                        value;
                    }}
                  />
                </FormItem>
              </div>
              <div className="ms-Grid-col ms-sm3">
                <FormItem
                  label="Spdc Samabri/Biseni"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="spdcSamabiriBiseni"
                    value={values?.spdcSamabiriBiseni}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.spdcSamabiriBiseni =
                        value;
                    }}
                  />
                </FormItem>
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm3">
                <FormItem
                  label="Spdc Tebidaba Unitized Share"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="spdcTebidaba"
                    value={values?.spdcTebidaba}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.spdcTebidaba =
                        value;
                    }}
                  />
                </FormItem>
              </div>
              <div className="ms-Grid-col ms-sm3">
                <FormItem
                  label="Spdc Oshie Share"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="spdcOshie"
                    value={values?.spdcOshie}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.spdcOshie = value;
                    }}
                  />
                </FormItem>
              </div>
              <div
                className="ms-Grid-col ms-sm3"
                style={{
                  backgroundColor: "#f2f2f2",
                  padding: "5px",
                  width: "215px",
                }}
              >
                {" "}
                <FormItem
                  label="Spdc Total Unitized Share"
                  labelAlign="left"
                  className="add-border"
                >
                  <span style={{ color: "#1890ff", fontWeight: "bold" }}>
                    {formatNumber(
                      naocDailyProductionStore.totalSpdcUnitizedShare,
                      {
                        precision: 2,
                        thousand: ",",
                      }
                    )}
                  </span>
                </FormItem>
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm3">
                <FormItem
                  label="Pillar/Newton Unitized Share"
                  labelAlign="left"
                  className="add-border"
                >
                  <InputNumber
                    min={0}
                    style={{ minWidth: "60%" }}
                    name="pillarNewton"
                    value={values?.pillarNewton}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.pillarNewton =
                        value;
                    }}
                  />
                </FormItem>
              </div>
              <div
                className="ms-Grid-col ms-sm3"
                style={{
                  backgroundColor: "#f2f2f2",
                  padding: "5px",
                  width: "215px",
                }}
              >
                <FormItem
                  label="Total Unitized Share"
                  labelAlign="left"
                  className="add-border"
                >
                  <span style={{ color: "#1890ff", fontWeight: "bold" }}>
                    {formatNumber(naocDailyProductionStore.totalUnitizedShare, {
                      precision: 2,
                      thousand: ",",
                    })}
                  </span>
                </FormItem>
              </div>
            </div>
            <Divider>FIELD REMARKS/NOTES</Divider>
            <MessageBar messageBarType={MessageBarType.warning}>Remarks are not populated automatically from the workbook due to inconsistency in entry pattern, please enter your daily production remarks </MessageBar>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm6">
                <FormItem
                  label="LAND AREA DAILY PRODUCTION REMARKS"
                  labelAlign="left"
                >
                  <ReactQuill
                    modules={{ toolbar: reactQuiltoolbarOptions }}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.landAreaRemarks =
                        value;
                    }}
                    value={
                      naocDailyProductionStore.initFormaData?.landAreaRemarks
                    }
                    style={{ minHeight: "300px" }}
                    placeholder="Enter REMARKS here"
                  />{" "}
                </FormItem>
              </div>
              <div className="ms-Grid-col ms-sm6">
                <FormItem
                  label="SWAMP AREA DAILY PRODUCTION REMARKS"
                  labelAlign="left"
                >
                  <ReactQuill
                    modules={{ toolbar: reactQuiltoolbarOptions }}
                    onChange={(value) => {
                      naocDailyProductionStore.initFormaData.swampAreaRemarks =
                        value;
                    }}
                    style={{ minHeight: "300px" }}
                    placeholder="Enter REMARKS here"
                    value={
                      naocDailyProductionStore.initFormaData?.swampAreaRemarks
                    }
                  />{" "}
                </FormItem>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
});

